(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const coarsePointer = window.matchMedia('(hover: none)');

  function initPax(root) {
    if (!root || root.dataset.nrPaxReady === 'true') return;
    root.dataset.nrPaxReady = 'true';

    const layers = Array.prototype.slice.call(root.querySelectorAll('[data-nr-pax-layer]'));
    const pillars = Array.prototype.slice.call(root.querySelectorAll('[data-nr-pax-pillar]'));
    const stage = root.querySelector('[data-nr-pax-stage]');

    let armed = null;

    function makeLegible() {
      root.classList.add('is-legible');
    }

    function playLayer(layer) {
      const video = layer.querySelector('[data-nr-pax-video]');
      if (!video) return;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(function () {});
    }

    function pauseLayer(layer) {
      const video = layer.querySelector('[data-nr-pax-video]');
      if (video) video.pause();
    }

    function setMedia(pillar) {
      const match = layers.filter(function (layer) {
        return layer.dataset.nrPaxLayer === pillar;
      })[0];
      const fallback = layers.filter(function (layer) {
        return layer.dataset.nrPaxLayer === 'default';
      })[0];
      const next = match || fallback;
      layers.forEach(function (layer) {
        const on = layer === next;
        layer.classList.toggle('is-active', on);
        if (on) playLayer(layer);
        else pauseLayer(layer);
      });
    }

    function setPillar(pillar) {
      pillars.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.nrPaxPillar === pillar);
      });
      setMedia(pillar);
    }

    function resetPillar() {
      armed = null;
      setPillar('default');
    }

    root.addEventListener('pointerleave', function () {
      if (!coarsePointer.matches) resetPillar();
    });

    if (coarsePointer.matches) {
      window.setTimeout(makeLegible, 3000);
    } else if (stage) {
      stage.addEventListener('pointerenter', makeLegible);
    }

    pillars.forEach(function (link) {
      const pillar = link.dataset.nrPaxPillar;
      link.addEventListener('pointerenter', function () {
        if (!coarsePointer.matches) setPillar(pillar);
      });
      link.addEventListener('focus', function () {
        makeLegible();
        setPillar(pillar);
      });
      link.addEventListener('click', function (event) {
        makeLegible();
        if (!coarsePointer.matches) return;
        if (armed !== link) {
          event.preventDefault();
          setPillar(pillar);
          armed = link;
        }
      });
    });

    setMedia('default');
    var drawCircle = root.dataset.nrPaxDraw !== 'false';
    var readyDelay = 0;
    if (drawCircle && !reduceMotion.matches && !root.classList.contains('is-ready')) {
      readyDelay = 2100;
    }
    window.setTimeout(function () {
      root.classList.add('is-ready');
    }, readyDelay);
  }

  function boot() {
    document.querySelectorAll('[data-nr-pax]').forEach(initPax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-nr-pax]');
    if (root) initPax(root);
  });
})();
